export const endpoints = {
	//auth
	urlToken: `${import.meta.env.VITE_API_URL}api/account/token/`,
	urlTokenRefresh: `${import.meta.env.VITE_API_URL}api/account/token/refresh/`,
	urlGetConfirmCode: `${import.meta.env.VITE_API_URL}api/account/password_reset/token/`,
	urlVerifyConfirmCode: `${import.meta.env.VITE_API_URL}api/account/password_reset/token/verify/`,
	urlResetPassword: `${import.meta.env.VITE_API_URL}api/account/password_reset/`,
	//forms
	login: `${import.meta.env.VITE_API_URL}api/account/token/form/`,
	email: `${import.meta.env.VITE_API_URL}api/account/password_reset/token/form/`,
	confirmCode: `${import.meta.env.VITE_API_URL}api/account/password_reset/token/verify/form/`,
	resetPassword: `${import.meta.env.VITE_API_URL}api/account/password_reset/form/`,
	changePasswordForm: `${import.meta.env.VITE_API_URL}api/account/password_change/form/`,
	loggingAddTask: `${import.meta.env.VITE_API_URL}api/project/project_time_tracking/create_form/`,
	projectsCreate: `${import.meta.env.VITE_API_URL}api/project/projects/create_form/`,
	vacationForm: `${import.meta.env.VITE_API_URL}api/employee/employee_vacation/create_form/`,
	dayoffForm: `${import.meta.env.VITE_API_URL}api/employee/employee_days_off/create_form/`,
	//other
	shortCurrentUserInfo: `${import.meta.env.VITE_API_URL}api/employee/current/short/`,
	fullCurrentUserInfo: `${import.meta.env.VITE_API_URL}api/employee/current/full/`,
	skillsList: `${import.meta.env.VITE_API_URL}api/employee/competence_category/`,
	currentUserCompetences: `${import.meta.env.VITE_API_URL}api/employee/employee_competence/`, //таблица области знаний
	changePassword: `${import.meta.env.VITE_API_URL}api/account/password_change/`,
	userLoggingList: `${import.meta.env.VITE_API_URL}api/project/project_time_tracking/?employee=`,
	addUserLogging: `${import.meta.env.VITE_API_URL}api/project/project_time_tracking/`,
	vacation: `${import.meta.env.VITE_API_URL}api/employee/employee_vacation/`,
	dayoff: `${import.meta.env.VITE_API_URL}api/employee/employee_days_off/`,
	user: `${import.meta.env.VITE_API_URL}api/employee/employees/`,
	userChoices: `${import.meta.env.VITE_API_URL}api/employee/employees/choices/`,
	project: `${import.meta.env.VITE_API_URL}api/project/project/`,
	projects: `${import.meta.env.VITE_API_URL}api/project/projects/`,
	projectJornal: `${import.meta.env.VITE_API_URL}api/project/project_diary_entries/`,
	projectMembers: `${import.meta.env.VITE_API_URL}api/project/project_employees/`,
	projectCreatePermit: `${
		import.meta.env.VITE_API_URL
	}api/permissions/permissions/current_department/`,
	projectEmployeesList: `${import.meta.env.VITE_API_URL}api/project/project_employees/?project=`,
	reports: `${import.meta.env.VITE_API_URL}api/project/time_tracking_report/`,
	reportProject: `${import.meta.env.VITE_API_URL}api/project/time_tracking_report/project/`,
	reportTaskOfProject: `${import.meta.env.VITE_API_URL}api/project/time_tracking_report/task/`,
	reportTaskOfEmployee: `${
		import.meta.env.VITE_API_URL
	}api/project/time_tracking_report/employee/`,
	permit: `${import.meta.env.VITE_API_URL}api/permissions/permissions/`,
	reportsDepartment: `${
		import.meta.env.VITE_API_URL
	}api/project/time_tracking_report/department/`,
	userRoles: `${import.meta.env.VITE_API_URL}api/permissions/permissions/current_department/`,
	reportCsv: `${import.meta.env.VITE_API_URL}api/project/time_tracking_report_csv/`,
	reportXLXS: `${import.meta.env.VITE_API_URL}api/project/time_tracking_report_xlsx/`,
	planningDayList: `${import.meta.env.VITE_API_URL}api/planning/day_list/`,
	planningForm: `${import.meta.env.VITE_API_URL}api/planning/employee_planning/create_form/`,
	planningEmployee: `${import.meta.env.VITE_API_URL}api/planning/employee_planning/`,
	planningEmployeeList: `${import.meta.env.VITE_API_URL}api/planning/employee_planning_list/`,
	planningProject: `${import.meta.env.VITE_API_URL}api/planning/project_planning/`,
	planningTotal: `${import.meta.env.VITE_API_URL}api/planning/total/`,
	planningChoices: `${
		import.meta.env.VITE_API_URL
	}api/planning/employee_planning_list/query_form/choices/`,
	analyticsMetrics: `${import.meta.env.VITE_API_URL}api/employee/employees/metrics/`,
	calendar: `${import.meta.env.VITE_API_URL}api/employee/employees/calendar/`,
	employees: `${import.meta.env.VITE_API_URL}api/employee/employees`,
	employeeCompetence: `${import.meta.env.VITE_API_URL}api/employee/competence/`,
	employeePositionGrade: `${import.meta.env.VITE_API_URL}api/employee/position_grade`,
	employeePosition: `${import.meta.env.VITE_API_URL}api/employee/position/`,
	employeesDeactivated: `${import.meta.env.VITE_API_URL}api/employee/employees/deactivated/`,
	cah: `${import.meta.env.VITE_API_URL}api/employee/cost_admin_hour/`,
	ssoProviders: `${import.meta.env.VITE_API_URL}api/account/oidc/providers/`,
	ssoUrl: `${import.meta.env.VITE_API_URL}api/account/oidc/auth-url/`,
	ssoLogin: `${import.meta.env.VITE_API_URL}api/account/oidc/callback/`,
};
